import SpecialMessage from './SpecialMessage';
export default SpecialMessage;
